<template>
  <tci-solution subtitle="" title="RPA" :infos='$i18n.locale=="zh"?infos:infos_ja' :images='$i18n.locale=="zh"?infos:infos_ja'></tci-solution>
</template>

<script>
import TciSolution from "@/components/TciSolution.vue";

export default {
  name: "CompanyService",
  components: {
    "tci-solution": TciSolution
  },
  data: () => ({
    infos: [{"imageUrl":require('../assets/solution/s4-1.jpg'),"title":"RPA（Robotic Process Automation）"},
    {"imageUrl":require('../assets/solution/s4-2.jpg'),"title":"UiPath平台（解决方案构成）"},
    {"imageUrl":require('../assets/solution/s4-3.jpg'),"title":"UiPath实施方法和依赖事项"}
    ],
    infos_ja: [{"imageUrl":require('../assets/solution/s4-1-ja.jpg'),"title":"RPA（Robotic Process Automation）"},
    {"imageUrl":require('../assets/solution/s4-2-ja.jpg'),"title":"UiPathプラットフォーム（ソリューション構成）"},
    {"imageUrl":require('../assets/solution/s4-3-ja.jpg'),"title":"UiPath実施方法及びご依頼事項"}
    ]
  })
};
</script>
